import {
  FETCH_DATA_RESTAURANT_SUCCESS,
  PRE_CHECK_SERVICE_OPEN_RESTAURANT,
  PRE_CREATE_TOKEN_STRIPE,
  REQUEST_UPDATE_FROZEN_SLOTS,
} from "../types/restaurant.types";

export const fetchDataRestaurant = datas => {
  return { type: FETCH_DATA_RESTAURANT_SUCCESS, datas };
};

export const createTokenRestaurant = (authCode, idRestaurant) => {
  return { type: PRE_CREATE_TOKEN_STRIPE, authCode, idRestaurant };
};

export const checkServiceOpenRestaurant = idRestaurant => {
  return { type: PRE_CHECK_SERVICE_OPEN_RESTAURANT, idRestaurant };
};

export const updateFrozenSlots = restaurantId => {
  return { type: REQUEST_UPDATE_FROZEN_SLOTS, restaurantId };
}